import JointLifeInformation from "components/Common/JointLifeInformation";
import { SinglePageLayoutContext } from "layout/SinglePageLayout";
import { useContext, useEffect } from "react";
import labels from "utils/LocalizedStrings";
import { useLocation } from "react-router";

const JointLifeInfo = () => {
  const singlePageLayoutContext = useContext(SinglePageLayoutContext);
  const location = useLocation();

  useEffect(() => {
    singlePageLayoutContext({
      id: "joint-life-info",
      title: labels?.jointLifeInfo?.title,
      buttonText: labels?.jointLifeInfo?.cancel,
      buttonPath: "/dashboard",
      description: "",
      hideCancelModal: true,
    });
  }, []);

  return (
    <section className="single-page-container">
      <JointLifeInformation
        labels={labels?.jointLifeInfo}
        data={location.state}
      />
    </section>
  );
};

export default JointLifeInfo;
